import React from 'react'
import { ViewReportList, bankTransferColumnDefinition } from 'pages/reports'
import { useGetMovementsReportQuery, useLazyGetMovementsReportQuery } from 'features'
import { ErrorBoundary, DateRangePicker } from 'components'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { dniFormatter } from 'formatters'
import { LazyReportExport } from 'pages/reports/LazyReportExport'

export default function ViewLiquidationReport() {
  const { dni = null } = useParams()

  /**
   * Holds the value of the selected date range for the listview component query builder
   */
  const [customFilterParams, setCustomFilterParams] = React.useState({
    fromdate: null,
    movementStatus: 'p,s,c',
    todate: format(new Date(), 'MM-dd-yyyy'),
  })
  /**
   * update the custom filter params when the date range picker changes
   * @param {string} name
   * @param {date} value
   */
  function handleDateRangeChange(name, value) {
    setCustomFilterParams({
      ...customFilterParams,
      [name]: format(value, 'MM-dd-yyyy'),
    })
  }
  return (
    <div>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div className="flex flex-row justify-between items-center mt-32  ">
          <Typography variant="h2" component="p" className="text-primary">
            {dni && 'DNI: ' + dniFormatter(dni)}
          </Typography>
          <div className="flex flex-row items-center justify-end flex-nowrap gap-4">
            <DateRangePicker
              toDate={customFilterParams.todate}
              fromDate={customFilterParams.fromdate}
              handleFromChange={(value) =>
                handleDateRangeChange('fromdate', value)
              }
              handleToChange={(value) => handleDateRangeChange('todate', value)}
            />
            <LazyReportExport
              query={useLazyGetMovementsReportQuery}
              columns={bankTransferColumnDefinition}
              title={`Liquidación ASL`}
              fileName={`Reporte liquidación ASL${dni && ' - DNI: ' + dni}}`}
              reportHeader={[
                ['Reporte de Liquidaciones ASL'],
                ['Movimientos desde:', customFilterParams.fromdate],
                ['Movimientos hasta:', customFilterParams.todate],
                [""]
              ]}
              queryParams={{
                params: {
                  ...customFilterParams,
                  dni: dni,
                  movementType: 'l',
                },
                paginated: false,
              }}
            />
          </div>
        </div>
        <ViewReportList
          query={useGetMovementsReportQuery}
          columnDefinition={bankTransferColumnDefinition}
          filterCustomParams={customFilterParams}
          rowIdKey={'movementid'}
          fixedParams={{ dni: dni, movementType: 'l' }}
        />
      </ErrorBoundary>
    </div>
  )
}
